/**
  * @ngdoc service
  * @name common.store.service:FavouriteStoreService
  * @requires imLocatorService
  * @description
  * Favourites store are enabled only for registered users.
  * Management of CRUD operations.
*/

(function() {
    'use strict';

    angular
    .module('itxApp.common')
    .service('FavouriteStoreService', FavouriteStoreService);
    
    FavouriteStoreService.$inject = ['$q','imLocatorService'];
    
    function FavouriteStoreService ($q,imLocatorService) {
        var _this = this;
        
        _this.favourites = 0;

        var service =  {
            toggleFavourite: toggleFavourite,
            addFavourite: addFavourite,
            deleteFavourite: deleteFavourite,
            setFavourites:  setFavourites,
            getFavourites: getFavourites
        };
         
        return service;
        /**
         * @ngdoc method
         * @name toggleFavourite
         * @methodOf  common.store.service:FavouriteStoreService
         * @description
         * Add or remove selected store to/from favourites checking isFavourite property.
         * @param {object} physicalStore  Store object
         * @returns {promise} boolean promise
        */
        function toggleFavourite(physicalStore){
            
            if(!physicalStore.isFavourite){
                return addFavourite(physicalStore);
            } else {
                return deleteFavourite(physicalStore);
            }
        }
        /**
         * @ngdoc method
         * @name addFavourite
         * @methodOf  common.store.service:FavouriteStoreService
         * @description
         * Add selected physical store object to the user's favourite store list.
         * @param {object} physicalStore  Store object
         * @returns {promise} boolean promise
        */
        function addFavourite(physicalStore){
            var deferred = $q.defer();

            var action = {
                action: 'bam:addFavouriteStore',
                params: {
                    storeId: inditex.iStoreId,
                    languageId: inditex.iLangId
                },
                data: {
                    'id': physicalStore.id
                }
            };

            joyr.rest.xRestExecute([action])
            .done(function(){                
                imLocatorService.addFavouriteStore(physicalStore);
                _this.favourites++;
                deferred.resolve(true);
            })
            .Catch(function(){
                deferred.reject(false);
            });

            return deferred.promise;

        }
        /**
         * @ngdoc method
         * @name deleteFavourite
         * @methodOf  common.store.service:FavouriteStoreService
         * @description
         * Removes a physical store from the user's list of favourite stores
         * @param {object} physicalStore  Store object
         * @returns {promise} boolean promise
        */
       function deleteFavourite(physicalStore){
            var deferred = $q.defer();

            var action = {
                action: 'bam:deleteFavouriteStore',
                params: {
                    storeId: inditex.iStoreId,
                    languageId: inditex.iLangId,
                    favouriteStoreId: physicalStore.id
                }
            };

            joyr.rest.xRestExecute([action])
            .done(function(){                
                imLocatorService.removeFavouriteStore(physicalStore);
                if(_this.favourites > 0){
                    _this.favourites--;
                }
                
                deferred.resolve(false);
            })
            .Catch(function(){
                deferred.reject(true);
            });

            return deferred.promise;
        }
         /**
        * @ngdoc method
        * @name setFavourites
        * @methodOf common.store.service:FavouriteStoreService
        * @param {number} favourites favourites stores
        * @description
        * Set the quantity of favourites stores
        */
        function setFavourites(favourites){            
            _this.favourites = favourites;
        }
        /**
        * @ngdoc method
        * @name getFavourites
        * @methodOf common.store.service:FavouriteStoreService
        * @returns {number} quantity of fav stores.
        * @description
        * Get the quantity of favourites stores
        */
        function getFavourites(){
            return _this.favourites;
        }

    }
        
})(window.itxApp);